module.exports = __webpack_public_path__ + "img/speaker.ccf744b7.gif";